import { Stack, styled } from '@mui/material';

import { getShouldForwardPropFn } from '@mopla/utils';

interface IStyledStack {
	filled: boolean;
	starSize?: number;
	disabled?: boolean;
}

export const StyledStack = styled(Stack, {
	shouldForwardProp: getShouldForwardPropFn<IStyledStack>(
		'filled',
		'starSize',
		'disabled'
	),
})<IStyledStack>(({ theme, filled, starSize = 24, disabled }) => ({
	alignItems: 'center',
	justifyContent: 'center',

	...(!disabled && { cursor: 'pointer' }),

	'> svg': {
		width: starSize,
		height: starSize,
		color:
			disabled || filled
				? theme.palette.neutral[80]
				: theme.palette.primary.main,
	},
}));
